import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const AuthCallback: React.FC = () => {
  const { completeCognitoLogin } = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Concluindo login...');
  const completedRef = useRef(false);

  useEffect(() => {
    const completeLogin = async () => {
      if (completedRef.current) return;
      completedRef.current = true;

      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error_description') || params.get('error');

      if (error) {
        setMessage(error);
        return;
      }

      if (!code || !state) {
        setMessage('Retorno de autenticação inválido.');
        return;
      }

      const result = await completeCognitoLogin(code, state);
      if (result.success) {
        navigate('/', { replace: true });
      } else {
        setMessage(result.message || 'Erro ao concluir login.');
      }
    };

    completeLogin();
  }, [completeCognitoLogin, navigate]);

  return (
    <main className="login-page">
      <div className="login-card-panel">
        <section className="login-card login-callback-card" aria-live="polite">
          <div className="login-mobile-logo login-callback-logo">
            <img src="/assets/incloud-logo.svg" alt="inCloud Tecnologia" />
          </div>
          <div className="login-card-heading">
            <p>Acesso ao painel</p>
            <h2>Validando sessao</h2>
          </div>
          <div className="login-auth-summary">
            <span />
            <p>{message}</p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default AuthCallback;
